import { render, staticRenderFns } from "./DeRichText.vue?vue&type=template&id=929292f8&scoped=true"
import script from "./DeRichText.vue?vue&type=script&lang=js"
export * from "./DeRichText.vue?vue&type=script&lang=js"
import style0 from "./DeRichText.vue?vue&type=style&index=0&id=929292f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929292f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('929292f8')) {
      api.createRecord('929292f8', component.options)
    } else {
      api.reload('929292f8', component.options)
    }
    module.hot.accept("./DeRichText.vue?vue&type=template&id=929292f8&scoped=true", function () {
      api.rerender('929292f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/DeRichText.vue"
export default component.exports